import { render } from "./IconProject.vue?vue&type=template&id=6e70fbd7"
import script from "./IconProject.vue?vue&type=script&lang=ts"
export * from "./IconProject.vue?vue&type=script&lang=ts"
script.render = render

export default script